import React from 'react';
import cn from 'classnames';
import ym from 'react-yandex-metrika';

import { Arrow } from '@/icons';

import styles from './info-card.module.scss';

export interface IProps {
  className?: string;
  id?: number;
  title: string;
  text?: string;
  type?: 'default' | 'link' | 'info';
  src?: string;
  imageClassName?: string;
  href?: string;
}

const InfoCard: React.FC<IProps> = (props) => {
  const {
    className,
    text,
    title,
    type = 'default',
    src,
    imageClassName,
    href
  } = props;

  const cardClassName = cn(styles.card, className, {
    [styles.card_link]: type === 'link',
    [styles.card_info]: type === 'info'
  });

  const handleClick = () => {
    ym('reachGoal', 'gain_access');
  };

  return (
    <>
      {type === 'link' ? (
        <a
          href={href}
          target='_blank'
          rel='noreferrer'
          className={cardClassName}
          onClick={handleClick}
        >
          <p className={styles.card__title}>{title}</p>
          {text && <p className={styles.card__text}>{text}</p>}
          {type === 'link' && <Arrow className={styles.card__arrow} />}
          {src && <img className={imageClassName} src={src} alt={title} />}
        </a>
      ) : (
        <div className={cardClassName}>
          <p className={styles.card__title}>{title}</p>
          {text && <p className={styles.card__text}>{text}</p>}
          {src && <img className={imageClassName} src={src} alt={title} />}
        </div>
      )}
    </>
  );
};

export default InfoCard;
